/* eslint-disable jsx-a11y/anchor-is-valid */
import { Component } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import PropTypes from 'prop-types';
import { Link } from 'next/link';
import Trans from 'next-translate/Trans';
import withTranslation from 'next-translate/withTranslation';
import { isDev } from '@utils/constants';

const errorLine = line => {
  const lineString = line.toString();

  return (<div><br/><span>&nbsp;&nbsp;{lineString}</span></div>);
};

const getErrorLinesHtml = lineList => (
  lineList.split(/\n/g).map(line => errorLine(line))
);

class ErrorBoundary extends Component {
  constructor (props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch (error, info) {
    // Display fallback UI
    this.setState({ error, hasError: true, info });

    if (!isDev) {
      datadogRum.addError(error, info);
    }
  }

  render () {
    const { t } = this.props.i18n;

    if (this.state.hasError) {
      // You can render any custom fallback UI
      if (isDev) {
        return (
          <div style={{ height: '100%' }}>
            <h1 style={{
              fontSize: '5rem',
              marginTop: '1em',
            }}
            >{t('page_error_boundary.something_went_wrong')}</h1>
            <span>&nbsp;&nbsp;{t('page_error_boundary.in_development_mode')}</span><br/>
            <span>&nbsp;&nbsp;{t('page_error_boundary.error_stack')}</span><br/>
            {getErrorLinesHtml(this.state.error.stack)}
            <br/><br/>
            <span>&nbsp;&nbsp;{t('page_error_boundary.error_info')}</span><br/>
            {getErrorLinesHtml(this.state.info.componentStack)}
          </div>
        );
      }

      return (
        <div style={{ height: '100%' }}>
          <h1 style={{
            fontSize: '5rem',
            marginTop: '1em',
          }}
          >{t('page_error_boundary.something_went_wrong')}</h1>
          <p>{t('page_error_boundary.ie_notice')}</p>
          <p>
            <Trans
              components={{
                // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
                home: <Link href="/" legacyBehavior><a /></Link>,
              }}
              i18nKey="common:page_error_boundary.contact_support_html"
            />
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  i18n: PropTypes.shape({ t: PropTypes.func.isRequired }).isRequired,
};

export default withTranslation(ErrorBoundary, 'common');
